import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Sync = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

<div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
  <div className="container px-0">
    <div className="shadowclass my-4">
      <div className="row mx-0">
        <div className="container px-0">
            <h4 class="event-alert w-100 mb-0"> POS Menu Index </h4>

            <div className="table-responsive">
              <table className="checklist-table remove-space inventory_table">
                <thead>
                  <tr>
                    <th> Last Updated At </th>
                    <th> Update Indexes Now </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="sub_class_row">
                    <td>
                    13-Jul-2022 04:04 PM
                    </td>
                    <td>
                      <a href="javascript:void(0)" class="update_index count-btn btn_btnblue">Re-Sync</a>
                    </td>
                  </tr>
                  <tr class="sub_class_row">
                    <td>
                    13-Jul-2022 04:04 PM
                    </td>
                    <td>
                      <a href="javascript:void(0)" class="update_index count-btn btn_btnblue">Re-Sync</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
      </div>
    </UserInterface>
  );
};
export default Sync;
